<template>
  <li class="timeline-item" :class="{'is-active': isActive}">
    <div class="timeline-item-timestamp">
      {{ timestamp|formatDate }}
    </div>
    <div class="timeline-item-divide">
      <div v-if="!isEnd" class="timeline-item__tail" />
      <div v-if="$slots['icon']" class="timeline-item__img-node">
        <slot name="icon" />
      </div>
      <div v-if="!$slots['icon']" class="timeline-item__node" />
    </div>
    <div class="timeline-item__wrapper">
      <div class="timeline-item__status">{{ status }}</div>
      <div class="timeline-item__content">
        <slot />
      </div>
    </div>
  </li>
</template>
<script>
export default {
  name: 'TimeLineItem',
  filters: {
    formatDate(val) {
      return val.replace(/-/g, '/')
    }
  },
  props: {
    timestamp: {
      type: String,
      default: () => ''
    },
    status: {
      type: String,
      default: () => ''
    },
    isEnd: {
      type: Boolean,
      default: () => false
    },
    isActive: {
      type: Boolean,
      default: () => false
    }
  },
  data: function() {
    return {

    }
  },
  created() {
    if (this.data && this.data.length > 0 && this.reverse) {
      this.data.reverse()
    }
  }
}
</script>
<style lang="scss" scoped>
  .timeline-item {
    display: flex;
    font-size: 14px;
    width: 278px;
    color: #333;
    &.is-active{
      .timeline-item__wrapper{
        .timeline-item__status{
            color: #BE2316;
            font-weight:bold;
        }
        .timeline-item__content{
          color:#333 !important;
        }
      }
    }
    .timeline-item-timestamp {
      text-align: center;
      width: 77px;
      height: 32px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 20px;
      opacity: 0.7;
    }
    .timeline-item-divide {
      text-align: center;
      position: relative;
      min-width: 24px;
      padding-left: 9px;
      padding-right: 12px;
      display: flex;
      justify-content: center;
      .timeline-item__tail {
        height: 100%;
        width: 1px;
        background: rgba(229, 229, 229, 1);
      }
      .timeline-item__node {
        position: absolute;
        background-color: #e4e7ed;
        width: 12px;
        height: 12px;
        border-radius: 50%;
      }
      .timeline-item__img-node {
        position: absolute;
        background-color: #e4e7ed;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        top: -6px;
        img {
          position: relative;
          height: 100%;
          width: 100%;
        }
      }
    }
    .timeline-item__wrapper {
      color:#999;
      position: relative;
      // padding-left: 18px;
      .timeline-item__status {
        font-size: 16px;
        margin-bottom: 10px;
      }
      .timeline-item__content{
        padding-bottom: 34px;
      }
    }
  }
</style>

